import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import VideoPopup from "../../common/Modals/VideoPopup";
import PortfolioSidebar from "./PortfolioSidebar";

const settings = {
  autoplay: true,
  autoplaySpeed: 4000,
  dots: false,
  fade: false,
  arrows: false,
};

const PortfolioPost = () => {
  const sliderRef = useRef(null);
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [portfolioData, setPortfolioData] = useState([]);

  useEffect(() => {
    const fetchPortfolioData = async () => {
      try {
        const response = await axios.get("https://palegoldenrod-panther-953114.hostingersite.com/admin/api/projects/read.php");
        console.log("API Response:", response.data); // Log the response
        // Ensure the response is an array
        if (Array.isArray(response.data.records)) {
          setPortfolioData(response.data.records);
        } else {
          console.error("Expected an array but got:", response.data);
          setPortfolioData([]); // Set to an empty array if not an array
        }
      } catch (error) {
        console.error("Error fetching portfolio data:", error);
      }
    };

    fetchPortfolioData();
  }, []);

  return (
    <>
      <div className="postbox__area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-12">
              <div className="postbox__wrapper mr-40">
                {Array.isArray(portfolioData) && portfolioData.map((post, index) => (
                  <article key={index} className="postbox__item format-image mb-50 transition-3">
                    <div className="postbox__thumb w-img">
                      <Link to={`/Portfolio-details/${post.id}`}>
                        <img src={`https://palegoldenrod-panther-953114.hostingersite.com/admin/${post.image_path}`} alt={post.title} />
                      </Link>
                    </div>
                    <div className="postbox__content">
                      <div className="postbox__meta mb-25">
                        <span>
                          <Link to="#">
                            <i className="fal fa-user"></i>{post.author}
                          </Link>
                        </span>
                        <span>
                          <i className="fal fa-calendar-day"></i>{post.date}
                        </span>
                        <span>
                          <Link to="#">
                            <i className="fal fa-comment"></i>{post.comments} COMMENT
                          </Link>
                        </span>
                      </div>
                      <h3 className="postbox__title">
                        <Link to={`/Portfolio-details/${post.id}`}>
                          {post.title}
                        </Link>
                      </h3>
                      <div className="postbox__text">
                        <p>{post.description.split(' ').slice(0, 200).join(' ')}...</p>
                      </div>
                      <div className="postbox__read-more">
                        <Link className="tp-btn-border" to={`/Portfolio-details/${post.id}`}>
                          read more
                          <span>
                            <svg
                              width="22"
                              height="8"
                              viewBox="0 0 22 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                            <svg
                              width="22"
                              height="8"
                              viewBox="0 0 22 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
            
          </div>
        </div>
      </div>

      {/* video modal start */}
      <VideoPopup
        isVideoOpen={isVideoOpen}
        setIsVideoOpen={setIsVideoOpen}
        videoId={"EW4ZYb3mCZk"}
      />
      {/* video modal end */}
    </>
  );
};

export default PortfolioPost;
